import React from 'react';
import { useParams } from 'react-router-dom';

import { BodyXS, FileSelector as PixelFileSelector, FileSelectorFileType, Box } from '@parspec/pixel';

import { environment } from 'src/environments';
import { SCHEDULE, SCHEDULE_ALLOWED_FILE_TYPE_STRING, SCHEDULE_ALLOWED_FILE_TYPES, SUBMITALL_PACKAGE_FILE_TYPE_STRING, SUBMITTAL_PACKAGE_ALLOWED_FILE_TYPES } from '../../ImportMoreProducts/shared/constants';


interface IFileType {
    file: FileSelectorFileType;
    s3_file_path?: string;
}

interface FileSelectorProps {
    radioInputValue?: string;
    fileRequiredError?: string;
    onUpload?: (files: IFileType[]) => void;
    onSelect?: (files: FileSelectorFileType[]) => void;
    label?: string;
    warning?: string;
}

const FileSelector: React.FC<FileSelectorProps> = ({
    radioInputValue,
    fileRequiredError,
    onUpload,
    onSelect,
    warning
}) => {
    const {projectId} = useParams()
    const acceptedFileTypes = radioInputValue === SCHEDULE ? SCHEDULE_ALLOWED_FILE_TYPES : SUBMITTAL_PACKAGE_ALLOWED_FILE_TYPES;
    const acceptedFileTypesString = radioInputValue === SCHEDULE ? SCHEDULE_ALLOWED_FILE_TYPE_STRING : SUBMITALL_PACKAGE_FILE_TYPE_STRING;
    return (
        <Box mt={2}>
            <PixelFileSelector
                url={`${environment.b}/api/generate_signed_url/?source=project_doc&id=${projectId}`}
                onSelect={onSelect}
                onUpload={onUpload}
                acceptedFormats={acceptedFileTypes}
                helperText={acceptedFileTypesString}
                error={fileRequiredError}
                placeholder="Drag and drop a file here, or:"
            />
            {warning && (
                <BodyXS color={'warning.main'} limit={false} mt={2}>
                    {warning}
                </BodyXS>
            )}
        </Box>
    );
};

export default FileSelector;
